import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { FontService } from 'src/app/services/font.service';
import { TextToSpeechService } from 'src/app/services/text-to-speech.service';
import { ValidationService } from 'src/app/services/validation.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { VrEventService } from 'src/app/services/vr-event.service';

@Component({
  selector: 'app-step-quiz-details',
  templateUrl: './step-quiz-details.component.html',
  styleUrls: ['./step-quiz-details.component.scss'],
})
export class StepQuizDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public originalName: string;
  public fontFamilyOptions: any[];
  public fontSizeOptions: number[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };
  public selectOptions = {
    cssClass: 'quizard-select'
  };
  public paginateConfig: any;
  public currentEventIndex: number = -1;
  public assetEvent: AssetEvent = null;
  public currentScene: Scene = null;

  constructor(
    public textToSpeechService: TextToSpeechService,
    public validationService: ValidationService,
    public vrEventTypeService: VrEventTypeService,
    public vrEventService: VrEventService,
    public vrEventTriggerService: VrEventTriggerService,
    public fontService: FontService,
    public deepCopyService: DeepCopyService
  ) {
    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
    this.fontSizeOptions = this.fontService.fontSizeOptions;
    this.paginateConfig = {
      itemsPerPage: 3,
      currentPage: 1
    };

    this.resetAssetEvent();
  }

  ngOnInit() {
    this.originalName = this.assetInScene.baseAsset.name;
    this.currentScene = this.existingScenes.find(s => s.sceneId == this.assetInScene.sceneAssetRelation.sceneId);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var sceneSettingsModal = document.getElementById('add-question-set-object-modal');
    sceneSettingsModal.style.opacity = opacity;
  }

  getQuestionSetAsset(): QuestionSetAsset {
    return this.assetInScene.baseAsset as QuestionSetAsset;
  }

  // ============ QUIZ DETAILS ==============

  textToSpeechChange(event, assetInScene: AssetInScene) {
    if (event.target.checked) {
      assetInScene.sceneAssetRelation.textToSpeechUrl = "Quiz";
    } else {
      assetInScene.sceneAssetRelation.textToSpeechUrl = null;
    }
  }

  backgroundVisibleChange(event, assetInScene: AssetInScene) {
    let questionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (event.target.checked) {
      questionSetAsset.backgroundOpacity = 1;
    } else {
      questionSetAsset.backgroundOpacity = 0;
    }
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  validateMinScoreToPassValue(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    var value = +event.target.value;
    value = this.validationService.validateMinValue(value, 0);
    value = this.validationService.validateMaxValue(value, 75);
    if (value != Math.floor(value)) {
      value = Math.floor(value) + 0.5;
    }
    questionSetAsset.minScoreToPass = Number(value);
  }

  validatePlaneColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.planeColour.trim().length == 0) {
      questionSetAsset.planeColour = "#FFFFFF";
    }
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.yScale = String(event.detail.value);

    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  validateDescriptionText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.questionSetDescription = questionSetAsset.questionSetDescription ? questionSetAsset.questionSetDescription : "";
    questionSetAsset.questionSetDescription = this.validationService.removeExcessLineBreaks(questionSetAsset.questionSetDescription);
  }


  // ============ ACTIONS ==============
  resetAssetEvent() {
    this.currentEventIndex = -1;
    this.assetEvent = this.vrEventService.getNewVrEvent() as AssetEvent;
  }

  getAssetName(sceneAssetRelationId: number): string {
    let asset = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if(this.assetInScene.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId || sceneAssetRelationId == 0)
      return "(Itself)";
    else if (asset)
      return asset.baseAsset.name;
    else
      return "";
  }

  getSceneName(sceneId: number): string {
    return this.existingScenes.find(s => s.sceneId == sceneId).name;
  }

  getEventTypes() {
    return this.vrEventTypeService.types;
  }

  getActiveAssetsInScene(): AssetInScene[] {
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId);
  }

  getActiveMediaAssetsInScene(): AssetInScene[] {
    return this.existingAssetsInScene.filter(a => a.toBeRemoved !== true 
      && a.sceneAssetRelation.sceneId == this.assetInScene.sceneAssetRelation.sceneId 
      && a.sceneAssetRelation.sceneAssetRelationId !== this.assetInScene.sceneAssetRelation.sceneAssetRelationId 
      && [5,6].includes(a.baseAsset.assetTypeId));
  }

  getActiveScenes(): Scene[] {
    return this.existingScenes.filter(s => s.active == true);
  }

  getEventType(eventTypeId) {
    return this.vrEventTypeService.getType(eventTypeId);
  }

  isObjectEventType(eventTypeId: number) {
    return this.vrEventService.isObjectEventType(eventTypeId);
  }

  shouldLinkToItself(eventTypeId: number){    
    return this.getEventType(eventTypeId) == "Hide Object";
  }

  isMediaEventType(eventTypeId: number) {
    return this.vrEventService.isMediaEventType(eventTypeId);
  }

  editAction(index: number) {
    this.currentEventIndex = index;

    this.assetEvent = this.deepCopyService.deepCopy(this.assetInScene.events[this.currentEventIndex]);
  }

  cancelAction() {
    this.resetAssetEvent();
  }

  saveAction() {
    if (this.assetEvent.eventTypeId <= 0 
      || Number(this.assetEvent.linkedContentId) < 0
      || this.assetEvent.eventTriggerId <= 0)
      return;

    if (this.currentEventIndex >= 0) {
      this.assetInScene.events[this.currentEventIndex] = this.deepCopyService.deepCopy(this.assetEvent);
    } else {
      this.assetInScene.events.push(this.deepCopyService.deepCopy(this.assetEvent));
    }

    this.resetAssetEvent();
  }

  deleteAction(index: number) {
    this.assetInScene.events.splice(index, 1);
  }

  // ============ INTRODUCTION PROPERTIES ==============

  setQuestionSetTitleSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.titleSize = parseFloat(value.toFixed(1));

  }

  validateTitleColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.titleColour.trim().length == 0) {
      questionSetAsset.titleColour = "#000000";
    }
  }

  setQuestionSetDescriptionSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.questionSetDescriptionSize = parseFloat(value.toFixed(1));

  }

  validateDescriptionColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.questionSetDescriptionColour.trim().length == 0) {
      questionSetAsset.questionSetDescriptionColour = "#000000";
    }
  }

}
